import * as React from 'react';
import { Card, CardBody, Box, Button } from '@chakra-ui/react';

interface Props {
  children?: React.ReactNode;
  onUpload: () => void;
  buttonLabelText?: string;
  complete?: boolean;
}

const UploadButtonSection: React.FC<Props> = (props: Props) => {
  const handleUploadClick = () => {
    props.onUpload();
  };

  return (
    <Card variant="filled" mb={6}>
      <CardBody display="flex" flexDirection="column" alignItems="center" textAlign="center">
        <Box mb={4}>{props.children}</Box>

        <Button
          id="upload-button"
          onClick={handleUploadClick}
          variant={props.complete ? 'secondary' : 'solid'}
          size="lg"
        >
          {props.buttonLabelText || 'Add or update files'}
        </Button>
      </CardBody>
    </Card>
  );
};

export default UploadButtonSection;
